// extracted by mini-css-extract-plugin
export default {"link":"TxLink_link__8MDKF"};